export default {"src":"https://images-cdn.curipod.com/d-f0cf23b3/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};